import * as React from 'react';
import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';
import {Theme} from '@mui/styles';
import {Typography, TextField, Button, IconButton} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize:"1rem"
  },
  instructions: {
    padding:15
  },
  formArea: {
    padding: 15
  }, 
  formField: {
    width: "40%"
  },
  fieldRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop:15
  },
  actionBar: {
    display: "flex",
    justifyContent: "flex-end"
  },
  itemDelete: {
    fontSize: "0.80rem",
    width: 45,
    height: 45
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  metadata: any;
  onMetadataChange: (newMetadata: Array<any>) => void;
}

// We will kepp internal state to give more metadata to the consumers, but we will always defer to the data coming from the props.
type State = {
  metadata: any;
};

class MetadataView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      metadata: this.toArray(this.props.metadata)
    };
  }

  handleAttributeChange = (idx:number) => (attribute:string) => (evt:any) => {
    const { metadata } = this.state
    metadata[idx][attribute] = evt.target.value
    this.setState({metadata})
    if(this.props.onMetadataChange){
      this.props.onMetadataChange(this.toObject(metadata))
    }
  }

  handleItemDelete = (idx:number) => (evt:any) => {
    const { metadata } = this.state
    var newMetadata: Array<any> = metadata.filter(function(value, arrIndex) {
      return idx !== arrIndex;
    });
    this.setState({metadata:newMetadata})
    if(this.props.onMetadataChange){
      this.props.onMetadataChange(this.toObject(newMetadata))
    }
  }

  handleItemAdd = (evt:any) => {
    const { metadata } = this.state
    metadata.push({})
    this.setState({metadata})
    if(this.props.onMetadataChange){
      this.props.onMetadataChange(this.toObject(metadata))
    }
  }


  toArray = (metadataObject:any):Array<any> => {
    const arr:Array<any> = []
    if(!metadataObject){
      return []
    }
    Object.keys(metadataObject).forEach((mo)=>{
      arr.push({label:mo, value:metadataObject[mo]})
    });

    return arr
  }
  
  toObject = (metadataArray:Array<any>):any => {
    return metadataArray.reduce((acc, i)=>{
      if(i.label && i.label.length > 0){
        acc[i.label] = i.value
      }
      return acc
    }, {})

  }

  render() {
    const {classes}: {classes: any} = this.props;
    const {metadata} = this.state



    let metadataArea:any = null
    if(metadata && metadata.length > 0){

      metadataArea = metadata.map((md:any, idx:any)=>{
        return (
          <div key={idx} className={classes.fieldRow}>
            <TextField
              className={classes.formField}
              id={"label_"+idx}
              name="label"
              value={md.label || ''}
              label="Label"
              onChange={this.handleAttributeChange(idx)('label')}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              className={classes.formField}
              id={"value_"+idx}
              name="value"
              value={md.value || ''}
              label="Value"
              onChange={this.handleAttributeChange(idx)('value')}
              InputLabelProps={{
                shrink: true
              }}
            />
            <IconButton size="large" aria-label="delete" className={classes.itemDelete} onClick={this.handleItemDelete(idx)}>
               <i className="fa fas fa-trash"/>
            </IconButton>
          </div>
        )
      })
    } else {
      metadataArea =  <Typography variant="body1">No metadata has been specified</Typography>
    }

    return (
      <div className={classes.container}>
        {metadataArea}
        <div className={classes.actionBar}>
          <Button color="primary" className={classes.button} onClick={this.handleItemAdd}>
            Add
          </Button>
        </div>
      </div>
    );

  }
}

export default withStyles(styles)(MetadataView);


